import { H3 } from "@blueprintjs/core"
import styled from "@emotion/styled"
import { FlexContainer, FlexContainerAndItem } from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"
import { LargeText } from "../../../../styled/text.styled"

export const HeaderContainer = styled(FlexContainer)({
  width: "100%",
  height: "40px",
})

export const TickerListContainer = styled(FlexContainerAndItem)({
  width: "90%",
  minHeight: "100px",
  maxHeight: "500px",
  overflow: "visible",
  flexShrink: 0,
  transition: "min-height 0.2s ease-in-out",
})

export const SummaryContainer = styled(FlexContainerAndItem)({
  width: "80%",
  overflow: "auto",
  backgroundColor: SCIENT_COLORS.darkWhite,
  borderRadius: "2px",
  padding: "10px",
  overflowY: "auto",
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  marginTop: "auto",
  maxHeight: "calc(100% - 184px)",
})

export const WaveTitle = styled(H3)({
  margin: 0,
})

export const TickersList = styled(LargeText)({
  marginTop: "2px",
})
